import {gql} from '@apollo/client';
import {DocumentNode} from 'graphql';

import FragmentWrapper from 'graphql-client/FragmentWrapper';
import {AnalyticsQuerySpecResponse} from 'insights/analytics-queries/RESTAnalyticsQueryTypes';
import pickDefined from 'util/pickDefined';

import {GraphQLAnalyticsQuerySpec} from './__generated/GraphQLAnalyticsQuerySpec';

const GRAPHQL_ANALYTICS_QUERY_SPEC_FRAGMENT: DocumentNode = gql`
  fragment GraphQLAnalyticsQuerySpec on AnalyticsQueryNode {
    id
    name
    description
    sqlQuery
  }
`;

export const GraphQLAnalyticsQuerySpecFragment: FragmentWrapper<GraphQLAnalyticsQuerySpec> = {
  fragment: GRAPHQL_ANALYTICS_QUERY_SPEC_FRAGMENT,
  fragmentName: 'GraphQLAnalyticsQuerySpec',
};

export function convertGQLToRESTAnalyticsQuery(
  gqlAnalyticsQuery: GraphQLAnalyticsQuerySpec
): AnalyticsQuerySpecResponse {
  return pickDefined(gqlAnalyticsQuery, 'id', 'name', 'description', 'sqlQuery');
}

export function convertRESTToGQLAnalyticsQuery(
  restAnalyticsQuery: AnalyticsQuerySpecResponse
): GraphQLAnalyticsQuerySpec {
  return {
    __typename: 'AnalyticsQueryNode',
    ...pickDefined(restAnalyticsQuery, 'id', 'name', 'description', 'sqlQuery'),
  };
}
